import { render } from "./blogPage.vue?vue&type=template&id=0cbf9fad&scoped=true"
import script from "./blogPage.vue?vue&type=script&lang=js"
export * from "./blogPage.vue?vue&type=script&lang=js"

import "./blogPage.vue?vue&type=style&index=0&id=0cbf9fad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbf9fad"]])

export default __exports__